import { getView } from '@/lib/utils';

export default {
  path: '/404',
  name: '404',
  component: getView('pages/PageNotFound'),
};
